import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-547acb7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex-column d-full-w d-overflow" }
const _hoisted_2 = { class: "search-wrap" }
const _hoisted_3 = { class: "d-flex row2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f h3" }, "历史记录", -1))
const _hoisted_5 = { class: "d-flex-1f row2-right" }
const _hoisted_6 = { class: "d-relative d-flex-1f history-inner" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "empty-wrap"
}
const _hoisted_9 = { class: "d-flex row2" }
const _hoisted_10 = { class: "d-flex-1f h3" }
const _hoisted_11 = { class: "d-relative d-flex-1f data-wrap" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_empty = _resolveComponent("empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_search, {
        shape: "round",
        class: "search",
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        "show-action": "",
        placeholder: "请输入商品/服务名称",
        onSearch: _ctx.onSearch,
        onCancel: _ctx.onCancel
      }, null, 8, ["modelValue", "onSearch", "onCancel"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "d-icobtn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.del && _ctx.del(...args)))
        }, [
          _createVNode(_component_van_icon, { name: "delete-o" })
        ])
      ])
    ]),
    (_ctx.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["history-wrap", {
                expanded: _ctx.isToggle,
            }]),
          ref: "historyWrap"
        }, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: "data-item",
                onClick: ($event: any) => (_ctx.itemClick(item))
              }, _toDisplayString(item), 9, _hoisted_7))
            }), 128))
          ]),
          (_ctx.showExpanded)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "arrow",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isToggle = !_ctx.isToggle))
              }, [
                _createVNode(_component_van_icon, {
                  name: _ctx.isToggle ? 'arrow-up' : 'arrow-down'
                }, null, 8, ["name"])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.data.length == 0 && _ctx.loading == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_empty, { msg: "没找到相关商品或服务哦，搜索其他关键字看看吧~" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createTextVNode(" 精品推荐 "),
        _createVNode(_component_van_icon, {
          name: "fire",
          color: "#ee0a24"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "data-item",
          key: item.id,
          onClick: ($event: any) => (_ctx.itemClickTag(item))
        }, _toDisplayString(item.name), 9, _hoisted_12))
      }), 128))
    ])
  ]))
}